import { useState } from "react";

import { LoadingState } from "@/components/loading-state";
import { Panel } from "@/components/panel";
import { useCouncilAsk } from "@/sdk/hooks/use-council";

export function PremortemPanel() {
  const [question, setQuestion] = useState("");
  const [result, setResult] = useState<string | null>(null);
  const ask = useCouncilAsk();

  const run = () => {
    const trimmed = question.trim();
    if (!trimmed) return;

    ask.mutate(
      {
        question: `Pre-mortem analysis: What are the 3 most likely reasons this prediction market resolves against consensus? Market: ${trimmed}`,
      },
      {
        // The real wire verdict carries the synthesized text as
        // consensus_answer (CouncilVerdictResponse, council.py).
        onSuccess: (value) => setResult(value.consensus_answer ?? null),
      },
    );
  };

  return (
    <Panel title="Pre-Mortem Analysis">
      <div className="space-y-3">
        <textarea
          className="w-full resize-none rounded-lg border border-white/10 bg-white/5 px-3 py-2 text-sm text-white placeholder-white/30 focus:outline-none"
          rows={2}
          placeholder="Market question or ID..."
          value={question}
          onChange={(event) => setQuestion(event.target.value)}
        />
        <button
          type="button"
          onClick={run}
          disabled={ask.isPending || !question.trim()}
          className="rounded bg-orange-600 px-3 py-1.5 text-xs text-white hover:bg-orange-500 disabled:opacity-50"
        >
          {ask.isPending ? "Analysing..." : "Run Pre-Mortem"}
        </button>
        <p className="text-xs text-amber-400/80">
          Runs a paid multi-provider council call — nothing fires without a question entered.
        </p>
        {ask.isPending ? <LoadingState text="Running pre-mortem..." /> : null}
        {ask.isError ? (
          <p className="text-sm text-red-400">
            Pre-mortem failed: {ask.error instanceof Error ? ask.error.message : "request error"}
          </p>
        ) : null}
        {result ? (
          <p className="border-l-2 border-orange-500/40 pl-3 text-sm leading-relaxed text-white/80">
            {result}
          </p>
        ) : null}
      </div>
    </Panel>
  );
}
